import React from 'react';
import { compose, graphql, Query } from 'react-apollo';
import {
  getMgbOrderById,
  refundOrder,
  refundMgbggbPickupTickets,
  refundMgbggbKeycardTickets,
  refundMgbggbBarcodeTickets,
} from '../schema/skidata-schema.graphql';
// @material-ui/core components
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
// core components
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';

import Landscape from '@material-ui/icons/Landscape';
import Money from '@material-ui/icons/Money';
import AttachMoney from '@material-ui/icons/AttachMoney';
import OrderDetailsForm from './OrderDetailsForm';
import Spinner from '../../../components/Spinner/Spinner';
import Payment from '../../payment/Payment';
import GridContainer from '../../../components/Grid/GridContainer';
import PickupTicketsSection from './PickupTicketsSection';
import KeycardTicketsSection from './KeycardTicketsSection';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import { OrderStateChip } from './OrderStateChip';
import QrCodeTicketsSection from './QrCodeTicketsSection';
import CashbackSection from './CashbackSection';
import localization from '../../../i18n/localization';
import tenantRoles from '../../../auth/tenantRoles';
import OrderChangeHistorySection from './OrderChangeHistorySection';
import { addCommentToOrder, addCancellationInfoToOrderHistory } from '../schema/skidata-schema.graphql'

class SkidataOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelling: false,
      orderChangeHistory: props.order && props.order.orderChangeHistory ? JSON.parse(props.order.orderChangeHistory) : [],
      sendingComment: false,
    };
  }

  onCancelFullOrder = async () => {
    const {
      cancelOrder,
      order,
      addNotification,
      refundVoucher = false,
      addCancellationInfoToOrder,
      updateOrderInformation,
    } = this.props;
    try {
      this.setState({ canceling: true });
      await cancelOrder({ variables: { orderId: order.id, refundVoucher } });
      const { data } = await addCancellationInfoToOrder({
        variables: {
          orderId: order.id,
          itemType: 'ORDER',
          itemIds: [order.saleId],
        },
      });
      this.setState({ canceling: false, orderChangeHistory: data.orderChangeHistory });
      updateOrderInformation();
      addNotification('success', 'Komplette Buchung erfolgreich storniert');
    } catch (error) {
      addNotification('error', 'Buchung konnte nicht storniert werden!');
      this.setState({ canceling: false });
    }
  };

  onCancelPickupTickets = async (
    ticketIds,
    sendConfirmationMail,
    refundVoucher = false
  ) => {
    const { cancelPickupTickets, order, addNotification, addCancellationInfoToOrder, updateOrderInformation } = this.props;
    try {
      this.setState({ canceling: true });
      await cancelPickupTickets({
        variables: {
          orderId: order.id,
          ticketIds,
          sendConfirmationMail,
          refundVoucher,
        },
      });
      const { data } = await addCancellationInfoToOrder({
        variables: {
          orderId: order.id,
          itemType: 'TICKET',
          itemIds: ticketIds,
        },
      });
      this.setState({ canceling: false, orderChangeHistory: data.orderChangeHistory });
      updateOrderInformation();
      addNotification(
        'success',
        `${ticketIds.length} Pickup-Ticket(s) storniert`
      );
    } catch (error) {
      addNotification(
        'danger',
        'Pickup Buchung konnte nicht storniert werden!'
      );
      this.setState({ canceling: false });
    }
  };

  onCancelKeycardTickets = async (
    ticketIds,
    sendConfirmationMail,
    refundVoucher = false
  ) => {
    const { cancelKeycardTickets, order, addNotification, addCancellationInfoToOrder, updateOrderInformation } = this.props;
    try {
      this.setState({ canceling: true });
      await cancelKeycardTickets({
        variables: {
          orderId: order.id,
          ticketIds,
          sendConfirmationMail,
          refundVoucher,
        },
      });
      const { data } = await addCancellationInfoToOrder({
        variables: {
          orderId: order.id,
          itemType: 'TICKET',
          itemIds: ticketIds,
        },
      });
      this.setState({ canceling: false, orderChangeHistory: data.orderChangeHistory });
      updateOrderInformation();
      addNotification(
        'success',
        `${ticketIds.length} Keycard-Ticket(s) storniert`
      );
    } catch (error) {
      addNotification(
        'danger',
        'Keycard Buchung konnte nicht storniert werden!'
      );
      this.setState({ canceling: false });
    }
  };

  onCancelBarcodeTickets = async (
    ticketIds,
    sendConfirmationMail,
    refundVoucher = false
  ) => {
    const { cancelBarcodeTickets, order, addNotification, addCancellationInfoToOrder, updateOrderInformation } = this.props;
    try {
      this.setState({ canceling: true });
      await cancelBarcodeTickets({
        variables: {
          orderId: order.id,
          ticketIds,
          sendConfirmationMail,
          refundVoucher,
        },
      });
      const { data } = await addCancellationInfoToOrder({
        variables: {
          orderId: order.id,
          itemType: 'TICKET',
          itemIds: ticketIds,
        },
      });
      this.setState({ canceling: false, orderChangeHistory: data.orderChangeHistory });
      updateOrderInformation();
      addNotification(
        'success',
        `${ticketIds.length} QrCode-Ticket(s) storniert`
      );
    } catch (error) {
      addNotification(
        'danger',
        'QrCode Buchung konnte nicht storniert werden!'
      );
      this.setState({ canceling: false });
    }
  };

  onRequestAddComment = async comment => {
    const { addInternalCommentToOrder, order, addNotification, updateOrderInformation } = this.props;
    try {
      this.setState({ sendingComment: true });
      const { data } = await addInternalCommentToOrder({
        variables: {
          orderId: order.id,
          comment,
        },
      });
      this.setState({ orderChangeHistory: data.orderChangeHistory, sendingComment: false });
      updateOrderInformation();
      addNotification(
        'success',
        `Neuer Kommentar wurde hinzugefügt`
      );
    } catch (error) {
      addNotification(
        'danger',
        'Kommentar wurde nicht hinzugefügt, es ist ein technischer Fehler aufgetreten'
      );
      this.setState({ sendingComment: false });
    }
  };

  render() {
    const { onUserClick, order } = this.props;
    const { canceling, sendingComment, orderChangeHistory } = this.state;
    const changeHistory = orderChangeHistory.length ? orderChangeHistory : (order && order.orderChangeHistory ? JSON.parse(order.orderChangeHistory) : []);

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="info">
                <Landscape />
              </CardIcon>

              <div
                style={{
                  marginTop: 60,
                  marginBottom: 25,
                  display: 'flex',
                  width: '100%',
                  alignItems: 'flex-start',
                }}
              >
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                  }}
                >
                  <Typography variant="headline" color="textSecondary">
                    Bestellungs &Uuml;bersicht
                  </Typography>
                </div>
                {order ? (
                  <React.Fragment>
                    <div style={{ marginRight: 25 }}>
                      <Chip
                        label={
                          order.visibleToUser
                            ? localization.de.visible
                            : localization.de.hidden
                        }
                        style={{
                          backgroundColor: order.visibleToUser
                            ? 'green'
                            : 'grey',
                          color: 'white',
                        }}
                      />
                    </div>
                    <div style={{ marginRight: 25 }}>
                      <OrderStateChip
                        state={order.state}
                        validFrom={order.tickets[0].validFrom}
                        validTo={order.tickets[0].validTo}
                      />
                    </div>
                    <Chip
                      label={order.user.email}
                      style={{
                        backgroundColor: '#00acc1',
                        color: 'white',
                      }}
                      clickable
                      onClick={() => onUserClick(order.user.id)}
                    />
                  </React.Fragment>
                ) : null}
              </div>
            </CardHeader>
            <CardBody>
              {order ? (
                <OrderDetailsForm
                  order={order}
                  canceling={canceling}
                  onCancelOrder={this.onCancelFullOrder}
                />
              ) : (
                <Spinner loading />
              )}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="info">
                <Money />
              </CardIcon>

              <div
                style={{
                  marginTop: 60,
                  display: 'flex',
                  width: '100%',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{ flex: 1 }}>
                  <Typography variant="headline" color="textSecondary">
                    Bezahlung
                  </Typography>
                </div>
              </div>
            </CardHeader>
            <CardBody>
              {order ? (
                <Payment payment={order.payment} order={order} />
              ) : (
                <Spinner loading />
              )}
            </CardBody>
          </Card>
        </GridItem>
        {order && order.cashbackInsurance ? (
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="info">
                  <AttachMoney />
                </CardIcon>

                <div
                  style={{
                    marginTop: 60,
                    marginBottom: 25,
                    display: 'flex',
                    width: '100%',
                    alignItems: 'flex-start',
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                    }}
                  >
                    <Typography variant="headline" color="textSecondary">
                      Cashback Versicherung
                    </Typography>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <CashbackSection cashbackInsurance={order.cashbackInsurance} />
              </CardBody>
            </Card>
          </GridItem>
        ) : null}
        {order ? (
          <QrCodeTicketsSection
            order={order}
            onCancelTickets={this.onCancelBarcodeTickets}
            canceling={canceling}
            role={[tenantRoles.MGB_ADMIN_WRITE]}
            onRequestAddComment={this.onRequestAddComment}
            sendingComment={sendingComment}
          />
        ) : null}
        {order ? (
          <PickupTicketsSection
            order={order}
            onCancelTickets={this.onCancelPickupTickets}
            canceling={canceling}
            role={[tenantRoles.MGB_ADMIN_WRITE]}
            onRequestAddComment={this.onRequestAddComment}
            sendingComment={sendingComment}
          />
        ) : null}
        {order ? (
          <KeycardTicketsSection
            order={order}
            onCancelTickets={this.onCancelKeycardTickets}
            canceling={canceling}
            role={[tenantRoles.MGB_ADMIN_WRITE]}
            onRequestAddComment={this.onRequestAddComment}
            sendingComment={sendingComment}
          />
        ) : null}
        {order ? (
            <OrderChangeHistorySection
              changeHistory={changeHistory}
            />
        ) : null}
      </GridContainer>
    );
  }
}

const enhance = compose(
  graphql(refundOrder, { name: 'cancelOrder' }),
  graphql(refundMgbggbPickupTickets, { name: 'cancelPickupTickets' }),
  graphql(refundMgbggbKeycardTickets, { name: 'cancelKeycardTickets' }),
  graphql(refundMgbggbBarcodeTickets, { name: 'cancelBarcodeTickets' }),
  graphql(addCommentToOrder, { name: 'addInternalCommentToOrder' }),
  graphql(addCancellationInfoToOrderHistory, { name: 'addCancellationInfoToOrder' }),
  withSnackbar
);

const SkidataOrderContainer = ({ history, match, ...rest }) => (
  <Query query={getMgbOrderById} variables={{ id: match.params.id }}>
    {({ data, refetch }) =>
      data ? (
        <SkidataOrder
          order={data.order}
          onUserClick={id => history.push(`/users/${id}`)}
          updateOrderInformation={refetch}
          {...rest}
        />
      ) : null
    }
  </Query>
);

export default enhance(SkidataOrderContainer);



// WEBPACK FOOTER //
// ./src/views/skidata/components/MgbOrder.jsx